'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Panel-module_container__3-aK1{box-sizing:border-box;display:flex;flex-direction:column;position:relative;width:100%}.Panel-module_headerContainer__WdnQN{border-top-left-radius:inherit;border-top-right-radius:inherit;overflow-x:auto;width:100%}.Panel-module_scrollableContainer__-q12f{border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;box-sizing:border-box;width:100%}.Panel-module_scrollableContainerScroll__g6fke{flex:1;overflow-y:auto}";
var styles = {"container":"Panel-module_container__3-aK1","headerContainer":"Panel-module_headerContainer__WdnQN","scrollableContainer":"Panel-module_scrollableContainer__-q12f","scrollableContainerScroll":"Panel-module_scrollableContainerScroll__g6fke Panel-module_scrollableContainer__-q12f"};
styleInject["default"](css_248z, 'acdbd639-7182-4401-be72-e0e7a848d359');

exports["default"] = styles;
